import { render, staticRenderFns } from "./RequestFeedbackModal.vue?vue&type=template&id=90b9e66c&scoped=true"
import script from "./RequestFeedbackModal.vue?vue&type=script&lang=js"
export * from "./RequestFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./RequestFeedbackModal.vue?vue&type=style&index=0&id=90b9e66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b9e66c",
  null
  
)

export default component.exports